import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";
import { AccountCircle as IconUser } from "@mui/icons-material";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiDialog from "components/Custom/UiDialog";

import { COMMON_JS } from "common/scripts";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { DateFunctions } from "common/datefunctions";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";

import { MASTER_APIs } from "apihandlers/master";
import { USER_APIs } from "apihandlers/user";
import Area from "components/Masters/Area";
import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";
import RichTxtBox from "components/Custom/RichTxtBox";

const SurveyActionTaken = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);

  const [users, setUsers] = useState([]);
  const [area, setArea] = useState([]);
  const [messageRow, setMessageRow] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );
  const [remarksList, setRemarksList] = useState([]);

  const usersRef: any = useRef(null);
  const areaRef: any = useRef(null);
  const messageGridRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "surveyDate",
      name: LABELS.SURVEY_DATE,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "areaName",
      name: LABELS.AREA,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "userName",
      name: LABELS.USER,
      width: "25%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "15%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const messageColumns = [
    {
      key: "type",
      name: LABELS.TYPE,
      width: "50%",
      type: "dropdown",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
      list: [
        {
          id: "New Region",
          label: "NEW REGION",
        },
        {
          id: "Competitor",
          label: "COMPETITOR",
        },
        {
          id: "Others",
          label: "OTHERS",
        },
      ],
    },
    {
      key: "comments",
      name: LABELS.COMMENTS,
      width: "50%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
  ];

  useEffect(() => {
    if (loading) {
      getUsers();
    }
  }, [loading]);

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getAsset();
        // getRows();
      }
    });
  };

  const getAsset = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setArea(list);
        // getRows();
      }
    });
  };
  // const getRows = () => {
  //   const args = {
  //     pageNo: 1,
  //     pageLength: DEFAULTS.PAGE_LENGTH,
  //   };
  //   MASTER_APIs.getVehicleChecks(args).then((res: any) => {
  //     const response: any = res.response;
  //     const { status } = res;
  //     if (status === 200) {
  //       let list = response.records;
  //       for (let i = 0; i < list.length; i++) {
  //         list[i]["slNo"] = i + 1;
  //         if (list[i]["activeStatus"]) {
  //           list[i]["activeStatus"] = "Yes";
  //         } else {
  //           list[i]["activeStatus"] = "No";
  //         }
  //       }
  //       setRows(list);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setMessageRow([]);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setMessageRow(JSON.parse(row.messages));
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const onSaveRemarks = () => {
    const comments = (
      document.querySelector("#remarks .ql-editor") as HTMLElement
    ).innerText;

    setRemarksList([...remarksList, { comments: comments }]);
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setGridLoading(false);
    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setLoading(true);

    CUSTOMER_APIs.getSurveys(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const manageRecord = () => {
    const userId = usersRef.current.selectedValue.id;
    const areaId = areaRef.current.selectedValue.id;
    const surveyDate = (
      document.getElementById("surveyDate") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";
    //todo:Validations needs to be done

    // Validations;
    let errors = [];
    if (!userId) {
      errors.push({
        id: "userId",
        msg:
          "<span class='bold'>" +
          LABELS.USER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!areaId) {
      errors.push({
        id: "areaId",
        msg:
          "<span class='bold'>" +
          LABELS.AREA +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      userId,
      areaId,
      surveyDate,
      messages: messageGridRef.getRowData(),
      activeStatus,
    };

    console.log("args", args);
    setIsSubmit(true);
    CUSTOMER_APIs.manageSurvey(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const getDeaultItemRow = () => {
    const newRow: any = {
      id: "1." + (messageGridRef.getRowData().length + 1).toString(),
    };
    return newRow;
  };

  console.log("Page: Survey:", messageRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.CRM_TRANSACTION}{" "}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SURVEY_ACTION_TAKEN}</li>
        </ul>
        <h4>{TITLES.SURVEY_ACTION_TAKEN}</h4>
        <p>{SUB_TITLES.SURVEY_ACTION_TAKEN}</p>
      </div>
      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <div
          className="formGroup"
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 14,
                marginTop: 6,
                marginRight: 8,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              padding: 10,
              marginTop: "0.3rem",
            }}
          >
            <Btn
              text={LABELS.LOAD}
              onClick={loadGrid}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </div>
      </div>
      {/* mandatoryResults */}
      {mandatoryLoadResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryLoadResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="grid excelGridWrapper">
        {!gridLoading &&
          (rows ? (
            <ExcelGrid
              id={"surveyActionTaken"}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.SURVEY_ACTION_TAKEN}
              onReload={reloadGrid}
              //   onAdd={onAdd}
            />
          ) : (
            <div className="flexRowCenter">
              <Loader />
            </div>
          ))}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " +
                TITLES.SURVEY_ACTION_TAKEN +
                ": " +
                selectedRow.areaName
              : "Add " + TITLES.SURVEY_ACTION_TAKEN
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
            setMandatoryLoadResults([]);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup  ">
              <TxtRow
                id={"surveyDate"}
                label={LABELS.SURVEY_DATE}
                defaultValue={
                  selectedRow.surveyDate
                    ? DateFunctions.getFormatedDate(
                        selectedRow.surveyDate,
                        FORMATS.SQL_DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                type={"date"}
                disabled={true}
              />
            </div>
            <div className="formGroup required ">
              <label>{LABELS.AREA}</label>
              {<span className="red">*</span>}
              <AutoComplete
                list={area}
                childRef={areaRef}
                defaultValue={
                  selectedRow.areaId
                    ? {
                        id: selectedRow.areaId,
                        label: selectedRow.areaName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={true}
              />
            </div>
            <div className="formGroup required">
              <label>{LABELS.USER}</label>
              {<span className="red">*</span>}
              <AutoComplete
                list={users}
                childRef={usersRef}
                defaultValue={
                  selectedRow.userId
                    ? {
                        id: selectedRow.userId,
                        label: selectedRow.userName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={true}
              />
            </div>

            <div className="formGroup ">
              <label>
                {LABELS.ACTIVE_STATUS}
                {/* <span>*</span> */}
              </label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: true,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: true,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                required={true}
                disabled={true}
              />
            </div>

            <div
              className="grid"
              style={{
                width: "100%",
                height: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ExcelGrid
                id={"message"}
                height={600}
                childRef={messageGridRef}
                cols={messageColumns}
                rows={messageRow}
                exportOption={false}
                newRowOption={false}
                // getDefaultNewRow={getDeaultItemRow}
              />
            </div>
            <div className="formGroup  ">
              <label>{LABELS.REMARKS}</label>
              <RichTxtBox id={"remarks"} />
            </div>
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.SAVE}
                onClick={onSaveRemarks}
                loading={isSubmit}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>

            {!loading && (
              <div className="width0">
                <div>
                  <p style={{ fontWeight: "bold", paddingLeft: "1rem" }}>
                    {" Remarks"}
                  </p>
                </div>
                <div
                  style={{
                    height: "16rem",
                    overflowY: "scroll",
                    padding: "1rem 1rem 1rem 1rem",
                  }}
                >
                  {remarksList &&
                    remarksList.map((items, index) => {
                      return (
                        <div id="responseList" key={index}>
                          <div>
                            <div>
                              <div className="responseHeader">
                                <div className="userBox">
                                  <div>
                                    <IconUser />
                                  </div>
                                  <p
                                    style={{
                                      padding: "0rem 0rem 0.5rem 0.5rem",
                                    }}
                                  >
                                    {items.personName}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <p
                                    style={{
                                      marginRight: 10,
                                    }}
                                  >
                                    {items.feedbackDate}
                                  </p>
                                </div>
                              </div>
                              <div className="responseText">
                                {items.comments}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}

            <div className="width40">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "open",
                    value: "open",
                    label: LABELS.OPEN,
                    checked: true,
                    disabled: false,
                  },
                  {
                    id: "close",
                    value: "close",
                    label: LABELS.CLOSED,
                    checked: false,
                    disabled: false,
                  },
                  {
                    id: "reOpen",
                    value: "reOpen",
                    label: LABELS.REOPEN,
                    checked: false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"status"}
                // disabled={isSubmit}
              />
            </div>

            {/* mandatoryResults */}

            {mandatoryResults.length > 0 && (
              <div className="mandatoryBox">
                <ul>
                  {mandatoryResults.map((m) => {
                    return (
                      <li>
                        <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="formGroup submitBtnWrapper">
              <div className="flexbtnjustify">
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    setManageDialog(false);
                    setMandatoryResults([]);
                    setMandatoryLoadResults([]);
                  }}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageRecord}
                  loading={isSubmit}
                  bgColor={COLORS.SAVE_GREEN}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(SurveyActionTaken);
